// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2VVPr","OrderButton":"BuildControls_OrderButton__2UpJl","enable":"BuildControls_enable__1NubC"};